import { defineMessages } from 'react-intl';

export default defineMessages({

  employerName: {
    id: 'fastCover.jobLossHardshipStep.employerName',
    defaultMessage: 'Employer Name',
  },
  employerEmail: {
    id: 'fastCover.jobLossHardshipStep.employerEmail',
    defaultMessage: 'Employer Email',
  },
  employerMailingAddress: {
    id: 'fastCover.jobLossHardshipStep.employerMailingAddress',
    defaultMessage: 'Employer mailing address',
  },
  address1: {
    id: 'fastCover.jobLossHardshipStep.address1',
    defaultMessage: 'Address 1',
  },
  address2: {
    id: 'fastCover.jobLossHardshipStep.address2',
    defaultMessage: 'Address 2',
  },
  city: {
    id: 'fastCover.jobLossHardshipStep.city',
    defaultMessage: 'City',
  },
  state: {
    id: 'fastCover.jobLossHardshipStep.state',
    defaultMessage: 'State',
  },
  province: {
    id: 'fastCover.jobLossHardshipStep.province',
    defaultMessage: 'Province',
  },
  country: {
    id: 'fastCover.jobLossHardshipStep.country',
    defaultMessage: 'Country',
  },
  zipOrPostalCode: {
    id: 'fastCover.jobLossHardshipStep.zipOrPostalCode',
    defaultMessage: 'ZIP / Postal Code',
  },
  dateOfTerminationRedundancy: {
    id: 'fastCover.jobLossHardshipStep.dateOfTerminationRedundancy',
    defaultMessage: 'Date of Termination / Redundancy',
  },
  howManyYearsDidYouWorkThere: {
    id: 'fastCover.jobLossHardshipStep.howManyYearsDidYouWorkThere',
    defaultMessage: 'How many years did you work there?',
  },
  describe: {
    id: 'fastCover.jobLossHardshipStep.describe',
    defaultMessage: 'Describe your above hardship request with enough detail so we can understand what happened?',
  },
  areYouGainfullyEmployedNow: {
    id: 'fastCover.jobLossHardshipStep.areYouGainfullyEmployedNow',
    defaultMessage: 'Are you gainfully employed now?',
  },
  haveYouBeenEmployedFullTime: {
    id: 'fastCover.jobLossHardshipStep.haveYouBeenEmployedFullTime',
    defaultMessage: 'Have you been employed full-time for at least 1 year by your prior employer?',
  },
  haveYouFiledForUnemploymentBenefits: {
    id: 'fastCover.jobLossHardshipStep.haveYouFiledForUnemploymentBenefits',
    defaultMessage: 'Have you filed for unemployment benefits?',
  },
  wasYourEmploymentStatusSeasonal: {
    id: 'fastCover.jobLossHardshipStep.wasYourEmploymentStatusSeasonal',
    defaultMessage: 'Was your employment status seasonal, partime, or self-employed?',
  },
  wasYourEmploymentStatusRetiredOrResigned: {
    id: 'fastCover.jobLossHardshipStep.wasYourEmploymentStatusRetiredOrResigned',
    defaultMessage: 'Was your employment status retired or resigned?',
  },
  haveYouBeenContinuouslyUnemployed: {
    id: 'fastCover.jobLossHardshipStep.haveYouBeenContinuouslyUnemployed',
    defaultMessage: 'Have you been continuously unemployed for 90 consecutive days?',
  },
  newEmployerName: {
    id: 'fastCover.jobLossHardshipStep.newEmployerName',
    defaultMessage: 'New Employer - Name',
  },
  newEmployerAddress: {
    id: 'fastCover.jobLossHardshipStep.newEmployerAddress',
    defaultMessage: 'New Employer - Address',
  },
  dateYouBeganNewEmployment: {
    id: 'fastCover.jobLossHardshipStep.dateYouBeganNewEmployment',
    defaultMessage: 'Date you began new employment',
  },
  isRequired: {
    id: 'fastCover.medicalHardshipStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  yes: {
    id: 'fastCover.medicalHardshipStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.medicalHardshipStep.no',
    defaultMessage: 'No',
  },
  checkEventDate: {
    id: 'fastCover.medicalHardshipStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/messages.js